import styled from 'styled-components';
export const ImageAspectBox = styled.div `
  position: relative;

  &::after {
    content: '';
    display: block;
    padding-bottom: ${props => (props === null || props === void 0 ? void 0 : props.ratio) * 100}%;
  }

  video,
  img,
  iframe,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: ${props => props.fit || 'cover'};
  }
`;
export const ImageAspectBox1x1 = styled(ImageAspectBox).attrs({
    ratio: 1,
    'data-aspect-ratio': '1x1',
}) ``;
export const ImageAspectBox16x9 = styled(ImageAspectBox).attrs({
    ratio: 9 / 16,
    'data-aspect-ratio': '16x9',
}) ``;
export const ImageAspectBox9x16 = styled(ImageAspectBox).attrs({
    ratio: 16 / 9,
    'data-aspect-ratio': '9x16',
}) ``;
export const ImageAspectBox21x9 = styled(ImageAspectBox).attrs({
    ratio: 9 / 21,
    'data-aspect-ratio': '21x9',
}) ``;
export const ImageAspectBox5x4 = styled(ImageAspectBox).attrs({
    ratio: 4 / 5,
    'data-aspect-ratio': '5x4',
}) ``;
export const ImageAspectBox3x5 = styled(ImageAspectBox).attrs({
    ratio: 5 / 3,
    'data-aspect-ratio': '3x5',
}) ``;
export const ImageAspectBox1x2 = styled(ImageAspectBox).attrs({
    ratio: 2 / 1,
    'data-aspect-ratio': '1x2',
}) ``;
//# sourceMappingURL=ImageAspectBox.js.map